import React from "react";
import { EaseModal } from "../../../libs/EaseModal";
import { Text1 } from "../../../styles";
import { SplitAccountConfigurationForm } from "../../Common/Forms/SplitAccount/SplitAccountConfigurationForm";

const ConfigureSplitAccountModal = (props) => {
  const renderTitle = () => {
    return (
      <Text1 className="d-block mb-4" strong>
        Configure Split Account
      </Text1>
    );
  };

  return (
    <EaseModal
      width={740}
      title={false}
      visible={props.visible}
      onCancel={props.onCancel}
      centered
      hideFooter
      destroyOnClose
    >
      {renderTitle()}
      <SplitAccountConfigurationForm {...props} />
    </EaseModal>
  );
};

export { ConfigureSplitAccountModal };
